/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */

import { I18n } from '@bingads-webui-grid/well-known';
import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton } from '@fluentui/react';
import React, { FC } from 'react';

interface RemoveDialogProps {
  hidden: boolean;
  i18n: I18n;
  columnSetName: string;
  onDismiss: () => void;
  onApply: () => void;
}

export const RemoveDialog: FC<RemoveDialogProps> = (props) => {
  const {
    hidden,
    columnSetName,
    onApply: onReplace,
    onDismiss,
    i18n,
  } = props;

  const dialogContentProps: IDialogContentProps = {
    type: DialogType.normal,
    closeButtonAriaLabel: i18n.getString(_TL_('Close')),
  };

  return (
    <Dialog
      hidden={hidden}
      onDismiss={onDismiss}
      dialogContentProps={dialogContentProps}
      styles={{
        main: {
          minHeight: 0,
        },
      }}
    >
      <p>
        {i18n.getString(_TL_('Are you sure you want to remove saved column set: {{savedColumnSetName}}'), { savedColumnSetName: columnSetName })}
      </p>
      <DialogFooter>
        <PrimaryButton onClick={onReplace} text={i18n.getString(_TL_('Remove'))} />
        <DefaultButton onClick={onDismiss} text={i18n.getString(_TL_('Cancel'))} />
      </DialogFooter>
    </Dialog>);
};
